<form
  class="flex w-full items-center gap-2 sm:w-auto lg:gap-4"
  [formGroup]="form"
>
  <div class="flex min-w-0 flex-1 items-center gap-2 sm:flex-none lg:gap-3">
    <label class="hidden text-sm font-medium xl:block">Escola:</label>
    <ui-select
      class="w-full min-w-0 lg:min-w-56"
      [options]="schools()"
      formControlName="school"
      bindLabel="schoolName"
      bindValue="schoolId"
      placeholder="Selecione"
      [clearable]="false"
      [isLoading]="isLoading()"
      [searchFn]="searchSchool"
    />
  </div>
  <div class="flex min-w-0 items-center gap-2 lg:gap-3">
    <label class="hidden text-sm font-medium xl:block">Ano:</label>
    <ui-select
      class="w-full min-w-0 lg:min-w-32"
      [options]="years()"
      formControlName="year"
      bindLabel="label"
      bindValue="value"
      placeholder="Selecione"
      [clearable]="false"
      [isLoading]="isLoading()"
    />
  </div>
</form>
